var module = angular.module('octopusApp.infrastructure');

module.directive('markitup', function () {
  // -------------------------------------------------------------------
  // markItUp!
  // -------------------------------------------------------------------
  // Copyright (C) 2008 Jay Salvat
  // http://markitup.jaysalvat.com/
  // -------------------------------------------------------------------
  // Modified for Octopus
  // -------------------------------------------------------------------

  var mySettings = function(element) {
    return {
      previewParserPath: '',
      onShiftEnter: {keepDefault: false, openWith: '\n\n'},
      markupSet: [
        {name: 'Bold', className: 'bold', key: 'B', openWith: '**', closeWith: '**'},
        {name: 'Italic', className: 'italic', key: 'I', openWith: '_', closeWith: '_'},
        {separator: '---------------' },
        {name: 'Bulleted List', className: 'bullet', openWith: '- ' },
        {name: 'Numeric List', className: 'numeric', openWith: function (markItUp) {
          return markItUp.line + '. ';
        }},
        {separator: '---------------' },
        {name: 'Picture', className: 'picture', key: 'P', replaceWith: '![[![Alternative text]!]]([![URL to image file:!:http://]!])'},
        {name: 'Link', className: 'link', key: 'L', openWith: '[', closeWith: ']([![URL:!:http://]!])', placeHolder: 'Your text to link here...' },
        {separator: '---------------'},
        {name: 'Code Block / Code', className: 'code', openWith: '(!(    |!|`)!)', closeWith: '(!(`)!)'},
        {name: 'Quotes', className: 'quotes', openWith: '> '}
      ],
      afterInsert: function () {
        var scope = element.scope();
        // Force the markup change to be written to the bound scope
        element.controller('ngModel').$setViewValue(element.val());
      }
    };
  };

  // -------------------------------------------------------------------

  return {
    restrict: 'A',
    link: function (scope, element) {
      element.markItUp(mySettings(element));
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/markitup.js
// module id = 669
// module chunks = 1